import { Settings } from "../../../Settings";
import Character from "../../character/Character";
import GridTile from "../../grid/GridTile";
import Vector from "../../math/Vector";
import PathPlan from "./PathPlan";

export default class PathPlanFallDownLeft extends PathPlan {
    /**
     * @param {GridTile} startTile 
     * @param {GridTile} endTile 
     * @param {number} pathSteps
     */
    constructor(startTile, endTile, pathSteps) {
        super(startTile, endTile, pathSteps);

        /**
         * @constant
         * @private
         * @type {Vector}
         */
        this.landCoordinate = new Vector(0, 0);
    }

    /**
     * @override
     * @param {Character} character 
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart True if this is the start of a turn.
     * @return {boolean} True when the step is completed.
     */
    executePlan(character, frameTimeRatio, turnStart) {

        // jump pixel: origin of start tile
        // land pixel: right edge of end tile
        const fallCoordinate = this.startTile.origin;
        const fallCoordinateX = fallCoordinate.x - Settings.character.halfWidth;  // we should walk until we just pass the start tile origin
        
        /////////////////////////////////////////////
        // Walk to fall coordinate
        /////////////////////////////////////////////

        if (character.position.worldCoordinateCenter.x > fallCoordinateX) {
            this.walkLeftToCenterX(character, frameTimeRatio, fallCoordinateX);
            return false;
        }

        /////////////////////////////////////////////
        // Fall down & Left
        /////////////////////////////////////////////

        // Land on the center of the end tile maybe
        this.landCoordinate.copy(this.endTile.origin);
        this.landCoordinate.addXY(Settings.tile.halfSize, 0); 
        
        if (character.position.worldCoordinateCenter.x > this.landCoordinate.x || character.position.worldCoordinateOrigin.y < this.endTile.origin.y) {
            this.fallDownAndLeft(character, frameTimeRatio, this.landCoordinate);
            return false;
        }

        // Note: Do not check for an open tile below when falling.

        this.assertEndTileReached(character, this.endTile);
        
        return true;
    }
    
    /**
     * @returns {String}
     */
    toString() {
        return 'FallDownLeft(' + this.pathSteps + ')';
    }
}